/* TARAYA cart. Loaded site-wide (the cart drawer is on every page).
   1. Reassurance line in the cart drawer footer.
   2. Quantity shown as a quiet line ("Quantity: 1 · Change") until the
      shopper asks to change it (cart drawer, cart page, product page).
   3. Cart badge pop and drawer content fade after cart updates. */

(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  var REASSURANCE = 'Insured shipping across India · Every piece certified';

  /* ---------- 1. Reassurance line ---------- */
  function injectReassurance() {
    var footer = document.querySelector('.cart-drawer__footer');
    if (!footer || footer.querySelector('.taraya-cart-reassure')) return;
    var el = document.createElement('p');
    el.className = 'taraya-cart-reassure';
    el.textContent = REASSURANCE;
    footer.insertBefore(el, footer.firstChild);
  }

  /* ---------- 2. Quantity line ----------
     The real stepper is hidden with display: none while data-taraya-qty is
     "rest" (see brand-taraya.css), which also removes it from the tab order;
     its value still submits with the form. "Change" reveals it and focuses
     the input. Without JavaScript the attribute is never set and the stepper
     shows as normal. */
  function enhanceQty(q) {
    if (q.dataset.tarayaQty) return;
    var input = q.querySelector('.quantity__input');
    if (!input) return;
    q.dataset.tarayaQty = 'rest';

    var line = document.createElement('button');
    line.type = 'button';
    line.className = 'taraya-qty-line';
    var text = document.createElement('span');
    text.className = 'taraya-qty-line__text';
    var action = document.createElement('span');
    action.className = 'taraya-qty-line__action';
    action.textContent = 'Change';
    line.appendChild(text);
    line.appendChild(action);

    function label() {
      var v = input.value || '1';
      text.textContent = 'Quantity: ' + v;
      line.setAttribute('aria-label', 'Change quantity, currently ' + v);
    }

    label();
    input.addEventListener('change', label);
    input.addEventListener('input', label);

    line.addEventListener('click', function () {
      q.dataset.tarayaQty = 'open';
      input.focus();
    });

    q.parentNode.insertBefore(line, q);
  }

  function enhanceAllQty() {
    document.querySelectorAll('quantity-input.quantity').forEach(enhanceQty);
  }

  /* ---------- 3. Micro-feedback ---------- */
  function initFeedback() {
    var MO = window.MutationObserver;
    if (!MO) return;

    var bubbleHost = document.getElementById('cart-icon-bubble');
    if (bubbleHost) {
      new MO(function () {
        var bubble = bubbleHost.querySelector('.cart-count-bubble');
        if (bubble) bubble.classList.add('taraya-pop');
      }).observe(bubbleHost, { childList: true });
    }

    var cartItems = document.getElementById('CartDrawer-CartItems');
    if (cartItems) {
      new MO(function () {
        var inner = cartItems.closest('.drawer__inner');
        if (!inner) return;
        inner.classList.remove('taraya-cart-refresh');
        void inner.offsetWidth;
        inner.classList.add('taraya-cart-refresh');
      }).observe(cartItems, { childList: true, subtree: true });
    }
  }

  onReady(function () {
    injectReassurance();
    enhanceAllQty();
    initFeedback();

    if (window.MutationObserver) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        new MutationObserver(function () {
          injectReassurance();
          enhanceAllQty();
        }).observe(drawer, { subtree: true, childList: true });
      }
      var cartPage = document.getElementById('main-cart-items');
      if (cartPage) new MutationObserver(enhanceAllQty).observe(cartPage, { subtree: true, childList: true });
    }
  });
  document.addEventListener('shopify:section:load', enhanceAllQty);
})();
